// app/pages/page-viewer/index.jsx

import React from 'react'
import {useParams} from 'react-router-dom'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PageNotFound from '@consteed/overrides/pages/page-not-found'
import usePageDesigner from '@consteed/frontend/utils/use-page-designer'

const PageViewer = () => {
    const {pageId} = useParams()
    try {
        const pageDesignerPage = usePageDesigner({pageId})

        return <Box>{pageDesignerPage}</Box>
    } catch (error) {
        return <PageNotFound />
    }
}

PageViewer.displayName = 'PageViewer'

export default PageViewer
